define(["../transitionFailureReasonModule",
        "json!../../monitoring.json",
        "json!../../tdnByEntity.json"],
    function (module, monitoring, tdnByEntity) {
        "use strict";

        return module.controller("TransitionFailureReasonControllerSearch", [
            "$scope",
            "$q",
            "monitoringService",
            "reload",
            "loadingService",
            "remoteExceptionHandler",
            "transitionFailureReasonService",
            "messagesModal",
            "tdnHelp",
            function ($scope, $q, monitoringService, reload, loadingService, remoteExceptionHandler, transitionFailureReasonService, messagesModal, tdnHelp) {

                $scope.serviceName = monitoring.services.transitionFailureReason;
                var template, paginationApi, paginationApiDefer = $q.defer();
                var filterApi, filterApiDefer = $q.defer();

                $scope.tdn = tdnByEntity?.[tdnHelp.getContext()]?.["transition-failure-reason"]

                $scope.search = function (modifiedTemplate) {
                    template = modifiedTemplate;
                    paginationApi.seekPage(1);
                };

                $scope.onRegisterFilterApi = function (api) {
                    filterApi = api;
                    filterApiDefer.resolve();
                };

                $q.all([paginationApiDefer.promise, filterApiDefer.promise]).then(function () {
                    filterApi.onChangeService(function (service) {
                        if (service === $scope.serviceName) {
                            if (reload) {
                                filterApi.reload();
                            } else {
                                filterApi.reset();
                            }
                        }
                    });
                });

                $scope.tableOptions = {
                    records: [],
                    pagination: {
                        onPaginate: function (firstResult, maxResults) {
                            return loadingService(monitoringService.filterTransitionFailureReasons(template, firstResult, maxResults))
                                .then(function (result) {
                                    return result;
                                }).catch(remoteExceptionHandler());
                        }
                    },
                    onRegisterPagination: function (api) {
                        paginationApi = api;
                        paginationApiDefer.resolve();
                    }
                };

                $scope.delete = function (record) {
                    if (record.defaultReason) {
                        messagesModal("dialog.error", {
                            keyBundle: "monitoring.transition.failure.reason.impossible.delete.default"
                        })
                    } else {
                        return transitionFailureReasonService.delete(record.id)
                            .finally(function () {
                                filterApi.reload();
                            });
                    }
                };
            }]);
    });